const blockedKeywords = [
    "javascript",
    'window.open',
    "script",
    'eval',
    'window.opener',
    'window.document',
    '<embed',
    'onerror',
    'onload',
    "javascript:",
    'alert',
    'document.cookie',
    'window.location',
    'setTimeout',
    'setInterval',
    'innerHTML'
];
const sanitizeText = (text)=>{
    const regex = new RegExp(blockedKeywords.join('|'), 'gi');
    return text.replace(regex, '');
};
export { sanitizeText };
